import React__default from 'react';
import '../box/index.js';
import '../spinner/index.js';
import '../stack/index.js';
import { Stack } from '../stack/stack.js';
import { Box } from '../box/box.js';
import { Spinner } from '../spinner/spinner.js';

/**
 * Simple footer element that can be used as InfiniteList's Footer component.
 * Allows nesting additional content in it via children
 */
const InfiniteListLoadingFooter = ({ children, }) => (React__default.createElement(Stack, { justifyContent: "center", alignItems: "center", direction: "column" },
    React__default.createElement(Box, { padding: "small" },
        React__default.createElement(Spinner, { size: "medium" })),
    children));

export { InfiniteListLoadingFooter };
